import type { StrapiSampleInformationRow } from '../../api/strapiCrm';
import type { DynamicEntityRow } from '../../api/strapiDynamicEntity';
import { filterSamplesForWorkOrderSamplingPlan } from '../SamplingSchedulesPage/samplingSchedulePlans';
import { extractPeralatanReferensiFromPlans } from '../PreSurveyPage/preSurveyUtils';
import { sampleLineAirFlag, type SamplingPlanAirGroup } from './samplingPlanAirGroup';
import {
  findSamplingPlanForAirGroup,
  findSamplingPlanForSampleLine,
  isAirGroupChecklistPlan,
} from './workOrderSamplingPlanEnsure';
import type { WorkOrderStatus } from './workOrderShared';

/** Sampling plan punya minimal satu referensi peralatan (PERALATAN_*). */
export function samplingPlanHasEquipmentAssigned(plan: DynamicEntityRow): boolean {
  return extractPeralatanReferensiFromPlans([plan]).length > 0;
}

function airGroupsPresentInSamples(
  samples: StrapiSampleInformationRow[],
): Set<SamplingPlanAirGroup> {
  const groups = new Set<SamplingPlanAirGroup>();
  for (const line of samples) {
    const flag = sampleLineAirFlag(line);
    if (flag === true) groups.add('air');
    if (flag === false) groups.add('non_air');
  }
  return groups;
}

/** Semua group air/non-air yang terlihat sudah punya checklist peralatan (1 plan per group). */
export function allVisibleSamplesHaveEquipmentChecklist(
  samples: StrapiSampleInformationRow[],
  plans: DynamicEntityRow[],
  quotationUsesGroups: boolean,
): boolean {
  const visible = quotationUsesGroups
    ? filterSamplesForWorkOrderSamplingPlan(samples, plans.filter((p) => !isAirGroupChecklistPlan(p)), true)
    : samples;
  if (visible.length === 0 || plans.length === 0) return false;

  const groups = airGroupsPresentInSamples(visible);
  if (groups.size > 0) {
    return [...groups].every((group) => {
      const plan = findSamplingPlanForAirGroup(plans, group);
      return plan != null && samplingPlanHasEquipmentAssigned(plan);
    });
  }

  // Fallback: sample tanpa perencanaan_sampling — cek plan per baris.
  return visible.every((line, idx) => {
    const plan = findSamplingPlanForSampleLine(line, idx, plans);
    return plan != null && samplingPlanHasEquipmentAssigned(plan);
  });
}

/** Naikkan status WO setelah checklist alat admin WO lengkap (draft → open). */
export function workOrderStatusAfterEquipmentChecklistComplete(
  current: WorkOrderStatus,
  allEquipmentChecklistComplete: boolean,
): WorkOrderStatus {
  if (!allEquipmentChecklistComplete) return current;
  if (current === 'draft') return 'open';
  return current;
}
